import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {computed, h} from 'vue';
import OrderActivity from "@/components/Layout/LayoutV2/EventsAndActivityPanel/Cards/OrderActivity.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ActivityPanelType',
  props: {
  recentActivity: {
    type: Object,
    default: () => ({})
  }
},
  setup(__props) {

const props = __props

// Dynamically determine the component to render based on the activity type
const getActivityTypeComponent = computed(() => {
  switch (props.recentActivity.subject_type) {
    case 'App\\Models\\v3\\Order\\Order':
      return h(OrderActivity, {recentActivity: props.recentActivity});
    default:
      return null;
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(getActivityTypeComponent.value)))
}
}

})